import React, { CSSProperties, FC, ReactElement } from 'react'
import { Avatar, Typography } from 'antd'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { ContactIcon } from './ContactIcon'
import { styles } from './style'

const { Text } = Typography

interface ContactDetailsProps {
  compact?: boolean
  style?: CSSProperties
  firstName?: string
  email?: string
  phone?: string
  avatarImageUrl?: string
}

const ContactDetails: FC<ContactDetailsProps> = ({
  compact = false,
  style,
  firstName,
  email,
  phone,
  avatarImageUrl,
}): ReactElement => {
  const s = styles(compact)

  return (
    <div style={{ ...style, ...s.root }}>
      <Text strong style={s.title}>
        {`Questions? ${firstName ? `${firstName} is` : "We're"} here to help`}
      </Text>
      {avatarImageUrl ? <Avatar src={avatarImageUrl} size={48} /> : <ContactIcon style={s.icon} />}
      <div style={s.details}>
        <div style={s.detailsRow}>
          <MailOutlined />
          <Text style={s.contactDetail}>{email ?? 'support@headbox.com'}</Text>
        </div>
        {phone && (
          <div style={{ ...s.detailsRow, marginLeft: compact ? 'unset' : 25 }}>
            <PhoneOutlined />
            <Text style={s.contactDetail}>{phone}</Text>
          </div>
        )}
      </div>
    </div>
  )
}

export { ContactDetails }
